import styled from 'styled-components'
import { CSVLink } from 'react-csv'

export const StyledDownloadSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const StyledDownloadLink = styled(CSVLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #00112b;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  &:hover {
    text-decoration: none;
    color: #00112b;
  }
`

export const StyledReportTypeSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #798498;
  font-weight: 700;
  line-height: 18px;

  & > svg {
    width: 18px;
    height: 20px;
    & > path {
      fill: currentColor;
    }
  }
`
